import React from "react";
import { InboxScreen } from "./view";
import { InboxController } from "./controller";
import { styles } from "./styles";

export class Inbox extends React.Component {
  static navigationOptions = {
    title: "Inbox"
  };

  constructor(props) {
    super(props);
    this.controller = new InboxController(props);
  }

  render() {
    return (
      <InboxScreen
        {...this.props}
        controller={this.controller}
        styles={styles}
      />
    );
  }
}
